import React from 'react';
import DeliveryRateCode from '../../components/DeliveryRateCode/default';

const index = () => {
  return (
    <div className="pt-10 max-w-[1600px] mx-auto ">
      <h1 className="text-2xl text-center font-extrabold pb-10">
        Delivery Rate Code
      </h1>
      <DeliveryRateCode />
    </div>
  );
};

export default index;
